export const getSearchResults = (callback = null, keyword = '', startIndex=0) => {
  fetch(`https://searchserverapi.com/getresults?api_key=${Searchanise.ApiKey}&q=${keyword}&startIndex=${startIndex}`)
    .then((response) => response.json())
    .then((response) => {
      if(callback) callback(response)
    })
    .catch((e) => {
      console.error(e)
    })
}